// extracted by mini-css-extract-plugin
export var addViewLink = "_t-1";
export var availabilityIcon = "_t-16";
export var availabilitySelectionIcon = "_t-15";
export var backButton = "_t-2";
export var backIcon = "_t-z";
export var conversationCount = "_t-3";
export var dragHandle = "_t-5";
export var dropdown = "_t-e";
export var dropdownIcon = "_t-7";
export var dropdownOption = "_t-6";
export var dropdownTriangle = "_t-d";
export var expand = "_t-f";
export var folder = "_t-i";
export var folderItem = "_t-c";
export var icon = "_t-8";
export var iconRow = "_t-9";
export var image = "_t-a";
export var logo = "_t-b";
export var navContainer = "_t-h";
export var navigationFooter = "_t-g";
export var pageShell = "_t-0";
export var placeholderAvailable = "_t-11";
export var placeholderBox = "_t-14";
export var placeholderBusy = "_t-13";
export var placeholderUnavailable = "_t-12";
export var profile = "_t-k";
export var profileContainer = "_t-m";
export var profileDropdown = "_t-n";
export var profileImage = "_t-l";
export var profileMain = "_t-o";
export var profileSubtitle = "_t-q";
export var profileTitle = "_t-p";
export var reorderIcon = "_t-r";
export var sentLine = "_t-u";
export var settingsHeader = "_t-s";
export var sidenavTextColor = "_t-y";
export var spamLine = "_t-t";
export var subitemWithTag = "_t-4";
export var supportItems = "_t-j";
export var teamText = "_t-10";
export var viewLine = "_t-x";
export var viewLineButton = "_t-w";
export var viewLineButtons = "_t-v";